export default __webpack_public_path__ + "static/media/area-chart.fc47317d.svg";